import { CoreIcon } from '../core-icon';
import mochiCoinCircleColorSVG from '../../assets/icons/mochi-coin-circle-color.svg';
import type { IconProps } from '../core-icon';

export const MochiCoinCircleColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={mochiCoinCircleColorSVG} {...props} />;
};
